import { MenuItem, MenuList } from '@mui/material';
import type { MapGeoJSONFeature } from '@vis.gl/react-maplibre';
import { Popup } from '@vis.gl/react-maplibre';
import type { Point } from 'geojson';

import { FeatureGuard } from '@/modules/FeatureGuard';
import { TrafficReport } from '@/modules/TrafficReport';

interface FeatureSelectMenuMarkerProps {
  features?: MapGeoJSONFeature[];
  onClose: () => void;
  onSelect: (feature: MapGeoJSONFeature) => void;
}

export function FeatureSelectMenuMarker({ features, onClose, onSelect }: FeatureSelectMenuMarkerProps) {
  return features ? (
    <Popup
      closeOnClick
      closeOnMove
      closeButton={false}
      latitude={(features[0].geometry as Point).coordinates[1]}
      longitude={(features[0].geometry as Point).coordinates[0]}
      maxWidth="50vw"
      offset={16}
      onClose={onClose}
    >
      <MenuList>
        {features

          .map((feature) => {
            let displayName;

            if (FeatureGuard.isTrafficReportFeature(feature)) {
              displayName = TrafficReport.title(feature) || 'Verkehrslage';
            } else if (FeatureGuard.isParkingFeature(feature)) {
              displayName = feature.properties.name ?? 'Parken';
            }

            const featureWithDisplayName: MapGeoJSONFeature & { displayName?: string } = feature;
            featureWithDisplayName.displayName = displayName;

            return featureWithDisplayName;
          })
          .map((feature, index) => (
            <MenuItem
              // eslint-disable-next-line react/no-array-index-key
              key={`${feature.id}${index}`}
              onClick={() => {
                onSelect(feature);
                onClose();
              }}
              sx={{
                color: 'text.secondary',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'block',
              }}
            >
              {feature.displayName ?? 'Unbekanntes Feature'}
            </MenuItem>
          ))}
      </MenuList>
    </Popup>
  ) : null;
}
